module.exports = __webpack_public_path__ + "static/img/mirror4.980bdb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirror4.png
// module id = bzAF
// module chunks = 2